/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationstrustCommerceTrustCommerceIntegration1 model module.
 * @module model/IntegrationstrustCommerceTrustCommerceIntegration1
 * @version v0.3
 */
export default class IntegrationstrustCommerceTrustCommerceIntegration1 {
  /**
   * Constructs a new <code>IntegrationstrustCommerceTrustCommerceIntegration1</code>.
   * @alias module:model/IntegrationstrustCommerceTrustCommerceIntegration1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationstrustCommerceTrustCommerceIntegration1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationstrustCommerceTrustCommerceIntegration1} obj Optional instance to populate.
   * @return {module:model/IntegrationstrustCommerceTrustCommerceIntegration1} The populated <code>IntegrationstrustCommerceTrustCommerceIntegration1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationstrustCommerceTrustCommerceIntegration1();
      if (data.hasOwnProperty('custid'))
        obj.custid = ApiClient.convertToType(data['custid'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('transaction_license_key'))
        obj.transactionLicenseKey = ApiClient.convertToType(data['transaction_license_key'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} custid
 */
IntegrationstrustCommerceTrustCommerceIntegration1.prototype.custid = undefined;

/**
 * @member {String} password
 */
IntegrationstrustCommerceTrustCommerceIntegration1.prototype.password = undefined;

/**
 * @member {String} transactionLicenseKey
 */
IntegrationstrustCommerceTrustCommerceIntegration1.prototype.transactionLicenseKey = undefined;

/**
 * @member {Boolean} enabled
 */
IntegrationstrustCommerceTrustCommerceIntegration1.prototype.enabled = undefined;

